import { render, staticRenderFns } from "./AddOrUpdateIncomeAndExpenses.vue?vue&type=template&id=b5dddd5a&scoped=true&"
import script from "./AddOrUpdateIncomeAndExpenses.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateIncomeAndExpenses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dddd5a",
  null
  
)

export default component.exports